import { API_URL } from '../../../app-config/constants';
import type { FeedbackParticipant, MiniFeedbackParticipant } from '../../../types/FeedbackParticipant';
import { get, post, put, remove } from '../request';

const BASE_URL = `${API_URL}/feedback-cycles`;

addParticipant.operation = 'NO_OPERATION';
addParticipant.invalidates = ['getParticipants'];
export function addParticipant(cycleId: string, requestId: string, userId: string): Promise<FeedbackParticipant[]> {
    return post(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants`, {
        postData: [{ id: userId }],
    });
}

removeParticipant.operation = 'NO_OPERATION';
removeParticipant.invalidates = ['getParticipants'];
export function removeParticipant(
    cycleId: string,
    requestId: string,
    participantId: string
): Promise<FeedbackParticipant[]> {
    return remove(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants/${participantId}`);
}

getParticipants.operation = 'READ';
export function getParticipants(cycleId: string, requestId: string): Promise<FeedbackParticipant[]> {
    return get(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants`);
}

provide.operation = 'NO_OPERATION';
provide.invalidates = ['getParticipants'];
export function provide(feedback: any, saveDraft: boolean): Promise<any> {
    return post(`${API_URL}/feedback/provide-feedback?saveDraft=${saveDraft}`, {
        postData: feedback,
    });
}

// TODO: should these be in their own file?
markCompleted.operation = 'NO_OPERATION';
markCompleted.invalidates = ['getParticipants', 'getPotentialUnsolicitedReviewees'];
export function markCompleted(cycleId: string, requestId: string, participantId: string): Promise<void> {
    return put(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants/${participantId}/completed`);
}

reOpen.operation = 'NO_OPERATION';
reOpen.invalidates = ['getParticipants', 'getPotentialUnsolicitedReviewees'];
export function reOpen(cycleId: string, requestId: string, participantId: string): Promise<void> {
    return remove(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants/${participantId}/completed`);
}

decline.operation = 'NO_OPERATION';
export function decline(cycleId: string, requestId: string, participantId: string, reason: string): Promise<void> {
    return put(`${BASE_URL}/${cycleId}/feedback-requests/${requestId}/participants/${participantId}/declined`, {
        postData: { reason },
    });
}
createUnsolicitedParticipant.operation = 'NO_OPERATION';
export function createUnsolicitedParticipant(feedbackRequestId: string): Promise<MiniFeedbackParticipant> {
    return post(`${API_URL}/feedback/new-unsolicited`, { postData: { feedbackRequestId } });
}

getPotentialUnsolicitedReviewees.operation = 'READ';
export function getPotentialUnsolicitedReviewees(
    cycleId: string,
    reviewerId: string
): Promise<MiniFeedbackParticipant[]> {
    return get(`${API_URL}/feedback/unsolicited/reviewees?cycleId=${cycleId}&reviewerId=${reviewerId}`);
}
